import { useState } from 'react';
import logoDark from 'core/common/assets/images/logoNebulaDark.svg';
import logoLight from 'core/common/assets/images/logoNebulaWhite.svg';
import { useRouter } from 'core/common/hooks';
import { Image } from 'core/common/ui/ui-kit';
import { Sidebar } from '../../Sidebar';
import { ButtonBack } from '../ButtonBack';
import { ButtonMenu } from '../ButtonMenu';
import { HeaderTempStyled, LogoBlockStyled } from './styled';

export const HeaderTemp = ({ variant = 'dark' }: { variant?: 'dark' | 'light' }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const router = useRouter();

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);

  const routeBack = async () => {
    router.back();
  };

  return (
    <>
      <HeaderTempStyled variant={variant}>
        <ButtonBack onBack={routeBack} hasPrevPath={false} />
        <LogoBlockStyled>
          <Image
            src={variant === 'dark' ? logoDark : logoLight}
            width={120}
            height={24}
            alt="logo"
          />
        </LogoBlockStyled>
        <ButtonMenu onClick={toggleSidebar} />
      </HeaderTempStyled>

      <Sidebar isOpen={isSidebarOpen} onClose={toggleSidebar} />
    </>
  );
};
